export enum ATTACHMENT_UPLOAD_STATUS {
    NEW = 'NEW',
    FAILED = 'FAILED',
    UPLOADED = 'UPLOADED',
    UPLOADING = 'UPLOADING'
}

/**  NOTE:
 *   upload-status:
 *        new: when just added and hasn't exceeded file upload size
 *        failed: either exceeded file upload size  or failed when uploading
 *        uploaded: when the file has been successfully uploaded
 *        uploading: when file is still uploading
 */
